import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import process from "../../../images/process.png";

const Process = () => {
  return (
    <Box paddingTop={{ xs: "25%", sm: "8%" }}>
      <Box>
        <Typography
          variant="h4"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#000"
            fontWeight={800}
            variant={"h4"}
          >
            Our {""}
          </Typography>
          Creative Process
        </Typography>
      </Box>
      <Box
        component="img"
        height={"100%"}
        width={{ xs: "100%", sm: "100%" }}
        data-aos={"fade-up"}
        sx={{
          display: "block",
          position: "relative",
          overflow: "hidden",
        }}
        src={process}
        alt={"process"}
      />
    </Box>
  );
};

export default Process;
